import { EventEmitter, OutputEmitterRef } from '@angular/core';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

// Validator which is intended to be applied at FormGroup level.
// Loops over child controls and sets form status to invalid when any of controls has error.
// Helpful in hybrid mode with angularjs.
export function formGroupValidator(
  validityEmitter: EventEmitter<boolean> | OutputEmitterRef<boolean>
): (formGroup: UntypedFormGroup) => ValidationErrors | null {
  return (formGroup: UntypedFormGroup): ValidationErrors | null => {
    let valid = true;
    for (const key in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(key)) {
        const control = formGroup.controls[key];
        valid = control.valid;

        if (!valid) {
          break;
        }
      }
    }

    validityEmitter.emit(valid);

    return valid ? null : { validateGroup: false };
  };
}
